import {IconButton} from "@mui/material";
import FilterIcon from "assets/icons/Filter";
import FilterModal from "pages/Faq/components/FilterModal";
import {useState} from "react";

const FilterButton = () => {
  const [openModal, setOpenModal] = useState<boolean>(false);

  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false)

  return (
    <>
      <IconButton
        onClick={handleOpenModal}
        sx={{
          borderRadius: 2,
          width: 40,
          height: 40,
          padding: 1,
          border: '1px solid',
          borderColor: 'grey.100',
        }}>
        <FilterIcon sx={{width: 20, height: 20, color: 'primary.main'}}/>
      </IconButton>
      <FilterModal open={openModal} onClose={handleCloseModal}/>
    </>
  )
}

export default FilterButton;
